/* globals ga */

// Use Google Universal Analytics with Turbolinks
// More info: gist.github.com/6045302
export default class GoogleAnalytics {
  constructor() {
    if (typeof window.ga !== 'undefined') {
      ga('set', 'location', location.href.split('#')[0]);
      ga('send', 'pageview');
    }
  }
}
